export const paymentsTypes = Object.freeze({
  ALL_ORDERS_VALUE: 'all',
  ORDERS_PAID_BY_CASH_VALUE: 'cash',
  ORDERS_PAID_THROUGH_DELIVEROO_VALUE: 'card',
});
